import { initConfig } from "./config/loader";
import { Navigation } from "./routes/router";
import { FirebaseProvider } from "./services/firebase/Provider";
import { ThemeWrapper } from "./services/theme";
import gsap from "gsap";
import { ScrollTrigger, ScrollToPlugin } from "gsap/all";
import { SnackbarProvider } from "notistack";
import "./i18n"; // Initialize i18n

// Registra ScrollTrigger
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

initConfig();

function App() {
  return (
    <div className="App bg-transparent">
      <FirebaseProvider>
        <ThemeWrapper>
          <SnackbarProvider>
            <Navigation />
          </SnackbarProvider>
        </ThemeWrapper>
      </FirebaseProvider>
    </div>
  );
}

export default App;
